import React from "react";

import CodeMirrorEditorHost from "components/organisms/editor/codemirror/CodeMirrorEditorHost";

function ManuscriptTextEditorHost({
    editorRef,
    editorContent,
    editorSessionKey,
    extensions,
    basicSetup,
    isRealtime = false,
    onEditorChange,
    onUpdate,
    onCreateEditor,
}) {
    return (
        <CodeMirrorEditorHost
            editorRef={editorRef}
            value={editorContent}
            sessionKey={editorSessionKey}
            extensions={extensions}
            basicSetup={basicSetup}
            className="manuscript-codemirror"
            style={{ height: "100%" }}
            isRealtime={isRealtime}
            onCreateEditor={onCreateEditor}
            onUpdate={onUpdate}
            onChange={(value, cursorPosition) => onEditorChange?.(value, cursorPosition)}
        />
    );
}

export default ManuscriptTextEditorHost;
